<template>
  <div
    class="flex flex-row flex-wrap items-center gap-4 text-center justify-center my-4 px-3 md:max-w-screen-sm mx-auto text-4xl"
  >
    <Component :is="currentView?.icon" class="shrink-0 w-[1em] h-[1em] text-primary" />

    <h1>{{ currentView?.title }}</h1>

    <p v-if="!!currentView?.description" class="basis-full text-[20px] leading-8 head font-medium text-balance px-6 mb-6">
      {{ currentView?.description }}
    </p>
  </div>
</template>

<script setup lang="ts">
import {
  UserAddIcon
} from "@heroicons/vue/outline";
import LoggedInUserIcon from "~/components/icons/LoggedInUser.vue";

const { t } = useI18n();
const route = useRoute();

const views = computed(() => [
  {
    key: "login",
    icon: LoggedInUserIcon,
    title: t("pages.account.page_header.title"),
    description: t("pages.account.page_header.description"),
  },
  {
    key: "signup",
    icon: UserAddIcon,
    title: "Account",
    description:
      "An account is optional and helps you place future home test kit orders faster.",
  }
]);

const currentView = computed(() => views.value.find((x) => x.key === route.params.page));
</script>
